import { useState, useEffect, useMemo, useCallback } from 'react';
import { DgtPdOrderPicklist } from '../models'
import { getDates } from '../utilities/Format'
import { PicklistStatus } from '../constants/EnumType'
import {
  getIssuedOrderPicklists,
  getPDCheckedOrderPicklists,
  getShortagedOrderPicklists,
  getHeaderPicklist
} from '../states/PicklistAction'

export default function usePdCheckOrderPicklist(
  status: string,
  orderType: string,
  dateFrom: Date,
  dateTo: Date,
  searchByOrder: string,
  division: string
) : DgtPdOrderPicklist[] {
  const [picklists, setPicklists] = useState<DgtPdOrderPicklist[]>([]);

  const fetchSinglePicklist = useCallback(async () => {
    const picklistHeader = await getHeaderPicklist(searchByOrder)
    if (picklistHeader) {
      setPicklists([ ...picklists, picklistHeader ])
    }
  }, [ searchByOrder, picklists ])

  useEffect(() => {
    const periodDates = getDates(dateFrom, dateTo)
    
    Promise.allSettled(periodDates.map(date => {
      if (status === PicklistStatus.WH_APPROVED) {
        return getIssuedOrderPicklists(date, division, orderType, false, true)
      } else if (status === PicklistStatus.PD_CHECKED) {
        return getPDCheckedOrderPicklists(date, division, orderType)
      } else if (status === PicklistStatus.WH_SHORTAGE) {
        return getShortagedOrderPicklists(date, division, orderType, false, true)
      }
      return Promise.reject(`Picklist Status not supported : ${status}`)
    })).then(results => {
      const totalPicklists = (results
        .filter(res => res.status === 'fulfilled') as PromiseFulfilledResult<DgtPdOrderPicklist[]>[])
        .reduce((prev, cur) => [...prev, ...cur.value], [] as DgtPdOrderPicklist[])
      setPicklists(totalPicklists)
    })
    .catch(err => console.error(err))
  }, [ status, orderType, dateFrom, dateTo, division ]);

  const filteredPicklists = useMemo(() => picklists.filter(pl => pl.pk.includes(searchByOrder)), [ searchByOrder, picklists ])

  if (filteredPicklists.length === 0 && searchByOrder.length === 8) fetchSinglePicklist()

  return filteredPicklists
}